import React from "react";
import { ModalWrapper } from "./ModalWrapper";

interface ContactDetailsModalProps {
    isOpen: boolean;
    onClose: () => void;
    contactName: string;
    contactPhone: string;
    contactRole: string;
}

export const ContactDetailsModal: React.FC<ContactDetailsModalProps> = ({
    isOpen,
    onClose,
    contactName,
    contactPhone,
    contactRole,
}) => {
    return (
        <ModalWrapper modalId="ContactDetailsModal"
            isOpen={isOpen}
            onClose={onClose}
            title="Contact Details"
            width="!max-w-2xl"
        >
            <div className="grid grid-cols-3 gap-4">
                {/* Name */}
                <div>
                    <label className="block text-sm font-medium text-[#366A75] mb-1">Name</label>
                    <div className="bg-[#EBF5F5] rounded px-3 py-2 border border-[#B4D9D4]">
                        <p className="text-sm text-[#366A75]" dir="rtl">{contactName || "-"}</p>
                    </div>
                </div>

                {/* Phone */}
                <div>
                    <label className="block text-sm font-medium text-[#366A75] mb-1">Phone</label>
                    <div className="bg-[#EBF5F5] rounded px-3 py-2 border border-[#B4D9D4]">
                        <p className="text-sm text-[#366A75]">{contactPhone || "-"}</p>
                    </div>
                </div>

                {/* Relation */}
                <div>
                    <label className="block text-sm font-medium text-[#366A75] mb-1">Relation</label>
                    <div className="bg-[#EBF5F5] rounded px-3 py-2 border border-[#B4D9D4]">
                        <p className="text-sm text-[#366A75]" dir="rtl">{contactRole || "-"}</p>
                    </div>
                </div>
            </div>
        </ModalWrapper>
    );
};
